import { ConfiguratorOptions } from '../types/ConfiguratorOptions';
import { ConnectSdkQueryParameter } from '../types/configuratorSdkTypes';

const getSubdomainUrl = (configuratorUrl: string): string => {
  // If the configuratorUrl already has a query string param
  // keep it and append any new ones
  const queryRegex = new RegExp(/\?[a-zA-Z0-9]+=/);
  if (queryRegex.test(configuratorUrl)) {
    return `${configuratorUrl}&`;
  }

  let subdomainUrl = configuratorUrl;

  if (configuratorUrl[configuratorUrl.length - 1] !== '/') {
    subdomainUrl += '/';
  }

  return `${subdomainUrl}?`;
};

export const generateConfiguratorUrl = (
  configuratorUrl: string,
  configuratorOptions?: Partial<ConfiguratorOptions>,
): string => {
  const subdomainUrl = getSubdomainUrl(configuratorUrl);

  const query = [`${ConnectSdkQueryParameter}`];
  let fragment = '';

  if (configuratorOptions) {
    if (configuratorOptions.postalCode) {
      query.push(`zip=${configuratorOptions.postalCode}`);
    }

    if (configuratorOptions.previewMode) {
      query.push('viewmode=preview');
    }

    if (configuratorOptions.dealer) {
      query.push(`dealer=${configuratorOptions.dealer}`);
    }

    if (configuratorOptions.uuid) {
      query.push(`uuid=${configuratorOptions.uuid}`);
    }

    if (configuratorOptions.hash) {
      fragment += `#${configuratorOptions.hash}`;
    }
  }

  return subdomainUrl + query.join('&') + fragment;
};
